import { supabase } from './supabaseClient'

// 🔐 CIFRAR
export async function encryptField(value) {

  // vacío
  if (!value || !value.trim()) {
    return null
  }

  const {
    data,
    error
  } = await supabase.functions.invoke(
    'secure-fields',
    {
      body: {
        action: 'encrypt',
        value
      }
    }
  )

  if (error) {
    console.error('Error cifrando:', error)
    return value
  }

  return data.result
}

// 🔓 DESCIFRAR
export async function decryptField(value) {

  if (!value) {
    return ''
  }

  const {
    data,
    error
  } = await supabase.functions.invoke(
    'secure-fields',
    {
      body: {
        action: 'decrypt',
        value
      }
    }
  )

  if (error) {
    console.error('Error descifrando:', error)
    return value
  }

  return data.result
}